import { apiClient } from './client.js';

export const searchApi = {
  global: (q) => apiClient.get('/search', { params: { q } }),
};
